import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import notificationsUtils from '../../../utils/notifications/notificationsUtils'
import selectors from '../../../store/shared/selectors'
import BlankCard from '../../../components/ui/cards/BlankCard'
import PageTitle from '../../../components/ui/typography/PageTitle'
import withTour from '../../../components/hocs/withTour'
import intercom from '../../../utils/intercom/intercomUtils'
import AssignTaskManager from './components/AssignTaskManager'
import StudentDetailsView from './components/StudentDetailsView/StudentDetailsView'
import InvitedPersonsWrapper from './components/InvitedPersonsWrapper'
import SignedUpPersonsWrapper from './components/SignedUpPersonsWrapper'
import StudentTasksCreateModal from './components/StudentTasksCreateModal'
import * as studentInvitationsDuck from './studentInvitiationsDuck'
import * as studentSignupsDuck from './studentSignupsDuck'

/**
 * @class AuthenticatedParentDashboardIndex
 * @description Dashboard for Parents to manage their Students
 */
class AuthenticatedParentDashboardIndex extends Component {
  /**
   * @static propTypes
   */
  static propTypes = {
    filteredInvitations: PropTypes.array.isRequired,
    filteredStudentSignups: PropTypes.array.isRequired,
    insToken: PropTypes.string,
    performInviteStudent: PropTypes.func.isRequired,
    performResendInvite: PropTypes.func.isRequired,
    performRetrieveStudentInvitations: PropTypes.func.isRequired,
    performRetrieveStudentSignups: PropTypes.func.isRequired,
    studentInvitationError: PropTypes.any,
    studentInvitationFormValues: PropTypes.any,
    studentSignups: PropTypes.array.isRequired,
    userId: PropTypes.string,
  }

  /**
   * @constructor
   */
  constructor(props) {
    super(props)

    /**
     * @method onInviteStudent
     * @description Invites a Student to Steppingblocks
     * @description Fires a success notification and closes invitation modal
     */
    this.onInviteStudent = () =>
      this.props
        .performInviteStudent(this.props.studentInvitationFormValues)
        .then(() => {
          notificationsUtils.showSuccessNotification('Invitation Sent!')
        })
        .catch(error => {throw new Error(error)})

    /**
     * @method onResendInvite
     * @description Resends an invitation to a student
     * @description Fires a success notification
     */
    this.onResendInvite = invitationId => {
      this.props
        .performResendInvite(invitationId)
        .then(() =>
          notificationsUtils.showSuccessNotification('Invitation Re-sent!'),
        )
        .catch(() => {})
    }

    /**
     * @method retrieveStudentInvites
     * @description Retrieves Student invitations
     */
    this.retrieveStudentInvites = () =>
      this.props.performRetrieveStudentInvitations()

    /**
     * @method retrieveStudentSignups
     * @description Retrieve your student signups
     */
    this.retrieveStudentSignups = () =>
      this.props.performRetrieveStudentSignups()
  }

  /**
   * @method componentWillMount
   * @description Fires off request to retrieve Student invitations for this parent
   */
  componentWillMount() {
    this.retrieveStudentInvites()
    this.retrieveStudentSignups()
  }

  componentDidMount() {
    intercom.intercomUpdate({
      user_id: this.props.userId,
    })
  }

  /**
   * @method render
   */
  render() {
    const {
      filteredInvitations,
      filteredStudentSignups,
      insToken,
      studentInvitationError,
      studentSignups,
    } = this.props

    return (
      <div>
        <div className="main-page">
          <PageTitle
            content="Parent Dashboard"
            tourName="parent"
          />
          <div className="row" id="onboardingSummary">
            <div className="col-sm-6">
              <BlankCard delay={0.7} title="Invited">
                <InvitedPersonsWrapper
                  data={filteredInvitations}
                  error={studentInvitationError}
                  insToken={insToken}
                  onInviteStudent={this.onInviteStudent}
                  onResendInvite={this.onResendInvite}
                />
              </BlankCard>
            </div>
            <div className="col-sm-6">
              <BlankCard delay={0.9} title="Signed Up">
                <SignedUpPersonsWrapper
                  data={filteredStudentSignups}
                />
              </BlankCard>
            </div>
          </div>
          <div id="studentDetails">
            <BlankCard delay={1.2} noPad={true}>
              <StudentDetailsView />
            </BlankCard>
          </div>
          <div id="taskManager">
            <BlankCard
              delay={1.5}
              title="Task Manager"
            >
              <AssignTaskManager />
            </BlankCard>
          </div>


        </div>
        <StudentTasksCreateModal studentSignups={studentSignups} />
      </div>
    )
  }
}

// Redux
const mapStateToProps = state => ({
  filteredInvitations: studentInvitationsDuck.getFilteredInvitations(state),
  filteredStudentSignups: studentSignupsDuck.getFilteredSignups(state),
  insToken: selectors.getInsToken(state),
  studentInvitationError: studentInvitationsDuck.getError(state),
  studentInvitationFormValues: selectors.getReduxFormValues(
    state.form.studentInvitationForm,
  ),
  studentSignups: studentSignupsDuck.getSignups(state),
  userId: selectors.getUserId(state),
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      performInviteStudent: studentInvitationsDuck.performInviteStudent,
      performResendInvite: studentInvitationsDuck.performResendInvite,
      performRetrieveStudentInvitations:
        studentInvitationsDuck.performRetrieveStudentInvites,
      performRetrieveStudentSignups:
        studentSignupsDuck.performRetrieveStudentSignups,
      setSignupActiveIndex: studentSignupsDuck.setActiveIndex,
    },
    dispatch,
  )


// Tour Steps
const tourSteps = [
  {
    selector: '#onboardingSummary',
    content: "View invites and sign ups or, invite new students by clicking the blue button.",
  },
  {
    selector: '#studentDetails',
    content: "Click a student on the left to view more. Here, an example student is shown.",
  },
  {
    selector: '#taskManager',
    content: 'Make sure your students are getting the most out of Steppingblocks by assigning tasks here.',
  },
  {
    selector: '#tasksCompleted',
    content: "We'll track your student's progress automatically, and show their progress here"
  }
]

export default connect(mapStateToProps, mapDispatchToProps)(
  withTour('parent', tourSteps)(AuthenticatedParentDashboardIndex),
)



// WEBPACK FOOTER //
// ./src/routes/authenticated/ParentDashboard/AuthenticatedParentDashboardIndex.js